import React, { useRef, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import clsx from "clsx";

import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "@transfr-inc/dashboard-components";

import { Button } from "@transfr-inc/dashboard-components/forms";

import "./course-gradebook-filter.modal.scss";
import { CourseGradebookFiltersInfo } from "./course-gradebook-filters-info";

export default ({
  open,
  onCancel,
  onApplyFilters,
  backdropClassName,
  modalClassName,
  className,
  onUpdateFilterCount,
  gradebookData,
  defaultUnit,
  selectedUser,
}) => {
  const unitFilterRef = useRef();
  const lessonsFilterRef = useRef();
  const traineesFilterRef = useRef();

  const [modalFilterCount, setModalFilterCount] = useState();

  const methods = useForm({
    criteriaMode: "all",
    mode: "onChange",
    defaultValues: {
      unit: defaultUnit,
      lessons: lessonsFilterRef.current ?? [],
      trainees: traineesFilterRef.current ?? [],
    },
  });

  const onApply = () => {
    onApplyFilters({
      unit: unitFilterRef.current,
      lessons: lessonsFilterRef.current,
      users: traineesFilterRef.current,
    });
    onUpdateFilterCount(modalFilterCount);
  };

  const onFiltersChangeHandler = (filters) => {
    let count = 0;
    if (filters.unit) {
      count++;
      unitFilterRef.current = filters.unit;
    }
    if (filters.lessons) {
      const lessons = filters.lessons.map((l) => l.data);
      lessonsFilterRef.current = lessons;
      count += filters.lessons.length;
    }
    if (filters.trainees) {
      const trainees = filters.trainees.map((t) => t.data);
      traineesFilterRef.current = trainees;
      count += filters.trainees.length;
    }
    setModalFilterCount(count);
  };

  return (
    <Modal
      open={open}
      onClose={onCancel}
      backdropClassName={backdropClassName}
      modalClassName={clsx("classroom-gradebook-filter-modal", modalClassName)}
    >
      <ModalHeader
        title={
          <div className="modal-title-badge">
            {"Filters"}
            {modalFilterCount > 0 && (
              <div className="badge">{modalFilterCount}</div>
            )}
          </div>
        }
        icon={["fa-regular", "sliders"]}
      ></ModalHeader>
      <ModalBody>
        <div className="course-gradebook-info">
          <FormProvider {...methods}>
            <form
              className={clsx("classroom-gradebook-filters-form", className)}
              noValidate={true}
            >
              <CourseGradebookFiltersInfo
                gradebookData={gradebookData}
                onFiltersChangeHandler={onFiltersChangeHandler}
                defaultUnit={defaultUnit}
                selectedUser={selectedUser}
              />
            </form>
          </FormProvider>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onApply} primary>
          Apply
        </Button>
      </ModalFooter>
    </Modal>
  );
};
